import { useCallback } from 'react';
import { doc, updateDoc, arrayUnion } from 'firebase/firestore';
import { db } from '../../../config/firebase';
import logger from '../../../utils/logger';

/**
 * Appends a recommendation record to the song doc (direct Firestore
 * arrayUnion; there is no dedicated callable for this write) and mirrors
 * it into local state so the UI updates without a refetch.
 */
const useSongRecommendActions = ({
  songDetails,
  setSongDetails,
  currentUser,
}) => {
  const handleRecommend = useCallback(
    async (recommendDetails) => {
      if (!currentUser) return;

      const recommendation = {
        ...recommendDetails,
        userId: currentUser.uid,
        displayName: currentUser.displayName || 'Anonymous',
      };

      try {
        const songRef = doc(db, 'songs', songDetails.id);
        await updateDoc(songRef, {
          recommendations: arrayUnion(recommendation),
        });
        setSongDetails((prev) => ({
          ...prev,
          recommendations: [
            ...(prev.recommendations || []),
            recommendation,
          ],
        }));
      } catch (error) {
        logger.error('Error adding recommendation:', error);
      }
    },
    [songDetails.id, currentUser, setSongDetails]
  );

  return { handleRecommend };
};

export default useSongRecommendActions;
